import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-employee-profile',
  templateUrl: './employee-profile.component.html',
  styleUrls: ['./employee-profile.component.scss']
})
export class EmployeeProfileComponent implements OnInit {
  isSlide: boolean = false;
  constructor() { }
  
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/employee-profile/employee-profile.component.ts